import {
    Box,
    Grid,
} from "@chakra-ui/react";

import FillPersonalDetailsForm from "./components/FillPersonalDetailsForm";
import LoginShowcase from "../Login/components/LoginShowcase";

const FillPersonalDetails = () => {
    return (
        <Box
            minH="100vh"
            bg="#F8FAFC"
        >
            <Grid
                minH={{
                    base: "auto",
                    lg: "100vh",
                }}
                templateColumns={{
                    base: "1fr",
                    lg: "1fr 1fr",
                }}
            >
                <FillPersonalDetailsForm />

                <Box
                    order={{
                        base: 2,
                        lg: 0,
                    }}
                    minH={{
                        base: "400px",
                        lg: "100vh",
                    }}
                >
                    <LoginShowcase />
                </Box>
            </Grid>
        </Box>
    );
};

export default FillPersonalDetails;